export enum FileRecordProcessingStatus {
  DRAFT = 'DRAFT', ERROR = 'ERROR', PROCESSING = 'PROCESSING', PROCESSED = 'PROCESSED'
}
